module.exports = __webpack_public_path__ + "static/media/space-station-moon-alt.a7830a6b.svg";